import { TakeFirstUseCase } from '../lib/take-first.use-case';
import type { AuthResponse } from '../types';

export class RefreshTokensUseCase extends TakeFirstUseCase<
  string,
  AuthResponse
> {
  public constructor(
    refreshTokenRequest: (token: string) => Promise<AuthResponse>
  ) {
    super({
      request: (token) => refreshTokenRequest(token),
    });
  }
}
